/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';

/**
 * Provides a utility hook to check the current user role has list
 * of FILE PERMISSIONS feature enabled.
 *
 * ```typescript
 *
 * import {useFilePermissionsFilter} from '@ion/applications/src/hooks/';
 *
 * const filePermissionsIds = useFilePermissionsFilter();
 *
 * ```
 *
 */
export const useFilePermissionsFilter = (Features: GenericObject, action: string) => {
  const extendedAttribute   = Features?._userRoles[0]?.extendedAttribute;
  const currentUserFeatures = extendedAttribute ? safeJSONParse(extendedAttribute?.value) : [];
  const filePermissions     = currentUserFeatures?.features?.find(
    (item) => item?.id === Features?.checkFilePermissionId('FILE_PERMISSIONS'))?.features || [];
  return filePermissions?.filter(
    item => item?.modules?.some(
      data => data?.name?.toLowerCase() === action && data?.enabled
    ))?.map(item => item?.modules?.[0]?.id?.split?.('-')?.[0]);
};

export default useFilePermissionsFilter;
